import { GetExamDetail, GetJobDetail, GetTestQuestionDetail, GetSource, GetHanoutTestList, GetHanoutList, GetHanoutDetail, GetHanout, GetWork, GetKaoShi, GetXiti, GetSucai, GetAllTeacher } from '@/api/resour'

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    // 获取试题详情
    async gettestdetail({ commit }, id) {
      const res = await GetTestQuestionDetail(id)
      return res
    },
    // 获取素材详情
    async getsource({ commit }, id) {
      const res = await GetSource(id)
      return res
    },
    // 获取讲义详情
    async gethanoutdetail({ commit }, id) {
      const res = await GetHanoutDetail(id)
      return res
    },
    // 获取讲义素材列表
    async gethanoutlist({ commit }, item) {
      const res = await GetHanoutList(item)
      return res
    },
    // 获取讲义试题列表
    async gethanouttest({ commit }, item) {
      const res = await GetHanoutTestList(item)
      return res
    },
    // 获取讲义库资源
    async gethanout({ commit }, item) {
      const res = await GetHanout(item)
      return res
    },
    // 获取作业库的资源
    async getwork({ commit }, item) {
      const res = await GetWork(item)
      return res
    },
    // 获取考试库的资源
    async getkaoshi({ commit }, item) {
      const res = await GetKaoShi(item)
      return res
    },
    // 获取习题库的资源
    async getxiti({ commit }, item) {
      const res = await GetXiti(item)
      return res
    },
    // 获取素材库的资源
    async getsucai({ commit }, item) {
      const res = await GetSucai(item)
      return res
    },
    // 发请求获取所有老师
    async getallteacher({ commit }, item) {
      const res = await GetAllTeacher(item)
      return res.results
    },
    // 获取作业详情
    async getjobdetail({ commit }, id) {
      const res = await GetJobDetail(id)
      return res
    },
    // 获取考试详情
    async getexamdetail({ commit }, id) {
      const res = await GetExamDetail(id)
      return res
    }
  }
}
